const DEFAULT_DATE_FORMAT = "MM/DD/YYYY";
const DEFAULT_DATETIME_FORMAT = "MM/DD/YYYY H:m";

export { DEFAULT_DATE_FORMAT, DEFAULT_DATETIME_FORMAT };